module.exports = __webpack_public_path__ + "static/media/al1.84e71000.mp4";